import React, { type FC } from "react";
import type L from "leaflet";
import { CustomControl } from "./CustomControl";

interface Props {
  position: L.ControlPosition;
  children?: React.ReactNode;
  container?: React.HTMLAttributes<HTMLDivElement>;
  prepend?: boolean;
}

/**
 * Leaflet 標準の `.leaflet-bar` スタイル（白背景・角丸・ボーダー・touch/retina対応・
 * 連結ボタンの上下マージ）に揃えたいコントロール用のラッパー。
 *
 * 子要素は Leaflet 流儀に合わせて `<a href="#" role="button">` で書くと、サイズ・
 * ホバー・disabled などが Leaflet の CSS（`.leaflet-bar a`）にそのまま乗る。
 *
 * `.leaflet-bar` を望まない独自パネル UI 用途には [[CustomControl]] を直接使う。
 */
export const LeafletBarControl: FC<Props> = ({ container, ...rest }) => {
  const mergedClassName = ["leaflet-bar", container?.className]
    .filter(Boolean)
    .join(" ");

  return (
    <CustomControl
      {...rest}
      container={{ ...container, className: mergedClassName }}
    />
  );
};
